// extracted by mini-css-extract-plugin
export default {"tabs":"MarketplacesTabs_tabs__0P5od","buttonContainer":"MarketplacesTabs_buttonContainer__LacsP"};